import Bs4File from './Bs4File'

export default class Bs4FileList extends Bs4File {

  listMode = true;
}